import { Container } from "react-bootstrap";
import Header from "../Components/Header";

const ContactEN = () => {
  return (
    <>
      <Header />
      <Container style={{ paddingTop: 32 }}>
        <h1>Contact Us</h1>
        <p style={{ paddingBottom: 24 }}>If you have any questions or suggestions about the 52 Weeks app, do not hesitate to contact me at <a href="mailto:contato@crjlab.com">contato@crjlab.com</a>.</p>
      </Container>
    </>
  );
}

export default ContactEN;